/* istanbul ignore file */
import { Component, input, InputSignal, ChangeDetectionStrategy } from '@angular/core';
import { CardMode } from '@components/card/card.component';
import { MdsExpansionPanelComponent } from '@medpacesoftwaredevelopment/designsystem';
import { PersistentFormArray, PersistentFormGroup } from '@utility/persistent-forms';
import { PassportInfoComponent, PassportInfoFormGroup } from './passport-info/passport-info.component';

export class InternationalPreferencesFormGroup extends PersistentFormGroup<{
    patientPassportInfo: PassportInfoFormGroup;
    caregiverPassportInfos: PersistentFormArray<PassportInfoFormGroup>;
}> {
    public static create(patientPassportInfo: PassportInfoFormGroup): InternationalPreferencesFormGroup {
        return new InternationalPreferencesFormGroup({
            patientPassportInfo: patientPassportInfo,
            caregiverPassportInfos: new PersistentFormArray<PassportInfoFormGroup>([]),
        });
    }
}
@Component({
    selector: 'medpace-international-preferences',
    templateUrl: './international-preferences.component.html',
    styleUrls: ['./international-preferences.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PassportInfoComponent, MdsExpansionPanelComponent],
})
export class InternationalPreferencesComponent {
    public readonly formGroup: InputSignal<InternationalPreferencesFormGroup> =
        input.required<InternationalPreferencesFormGroup>();
    public readonly mode: InputSignal<CardMode> = input.required<CardMode>();
}
